'use client';
import Breadcrumbs from '../Breadcrumbs';
import { usePagesContext } from '@osmosis/nextjs-components/context';
import { useLearnData } from '../../../context/LearnDataProvider';
import { getBreadcrumbTrackHandler } from '../../../lib/tracking';
import { BreadcrumbV2Object } from '@osmosis/shared/types/learn';
interface LearnBreadcrumbsProps {
  sectionName: string;
  breadcrumbs?: BreadcrumbV2Object[];
}

/**
 * Renders Breadcrumbs on the header of the video learn page.
 */
const LearnBreadcrumbs = (props: LearnBreadcrumbsProps) => {
  const { sectionName, breadcrumbs } = props;
  const { query } = usePagesContext();
  const { learnData, isLoading } = useLearnData();

  const handleTrackBreadcrumb = getBreadcrumbTrackHandler('learn-page');

  if (isLoading)
    return (
      <Breadcrumbs
        breadcrumbsv2={breadcrumbs}
        sectionName={sectionName}
        justifyDropdown={'flex-start'}
        onBreadCrumbItemClick={handleTrackBreadcrumb}
        linkClassName="text-xs"
      />
    );

  // we will have two sets of breadcrumbs until we get it all implemented, then we'll remove the old set
  const { breadcrumbsv2 } = learnData || {};

  if (!breadcrumbsv2) return null;

  const fromBreadcrumbsv2Index = breadcrumbsv2.findIndex(
    (breadcrumb) => breadcrumb.link === query.from,
  );

  if (fromBreadcrumbsv2Index > -1) {
    const fromBreadcrumbsv2 = breadcrumbsv2.splice(fromBreadcrumbsv2Index, 1);
    breadcrumbsv2.unshift(fromBreadcrumbsv2[0]);
  }

  return (
    <Breadcrumbs
      breadcrumbsv2={breadcrumbsv2}
      sectionName={sectionName}
      justifyDropdown={'flex-start'}
      onBreadCrumbItemClick={handleTrackBreadcrumb}
      linkClassName="text-xs"
    />
  );
};

export default LearnBreadcrumbs;
